import RestService from './RestService';

class User {}

User.isAuthenticated = () => {
	return localStorage.getItem('access_token');
};

User.get = () => {
	const user = localStorage.getItem('user');
	if (user) return JSON.parse(user);
	return null;
};

User.getRoles = () => {
	const user = User.get();
	const roles = user.Roles ? user.Roles : [];

	return roles;
};

User.hasRoles = (role) => {
	const roles = role && Array.isArray(role) ? role : [role];
	return User.getRoles().some((el) => roles.some((r) => el === r));
};

User.logout = (path) => {
	if (localStorage.fcm_token) RestService.post({ path: 'notification/unregister', data: { token: localStorage.fcm_token } });
	localStorage.clear();
	document.location = path ? path : '/';
};

export default User;
